import * as React from 'react'
import {ResponsiveValue} from '@miro-site/core'
import IconBase from '../icons/IconBase'

const LogoSquare: React.FC<{
  width?: ResponsiveValue<string | number>
  height?: ResponsiveValue<string | number>
}> = ({width = 48, height = 48, ...props}) => {
  return (
    <IconBase $styles={{width, height}} viewBox="0 0 48 48" {...props}>
      <rect width="48" height="48" rx="10.4" fill="#FFD02F" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.3415 6H28.0732L32.4634 13.7143L22.8049 6H17.5366L22.3659 15.4286L12.2683 6H7L12.2683 18L7 42H12.2683L22.3659 16.2857L17.5366 42H22.8049L32.4634 14.5714L28.0732 42H33.3415L43 12L33.3415 6Z"
        fill="#050038"
      />
    </IconBase>
  )
}

export default LogoSquare
